import { axiosNT, axiosNTL, axiosNL } from '../../../services/axios';
import axios from '../../../services/axios';
import { UserRoleBody } from '../types/UserRolesBody';
import { rolesEnum } from '../types/RolesEnumBody';

const listUserRoles = () => {
    return axiosNT.get('/role')
        .then((res: any) => {
            let goalOfList: UserRoleBody[] = res.responseObject;
            return Promise.resolve(goalOfList);
        });
}

const getRolesEnum = () => {
    return axiosNTL.get('/role/roleEnum')
        .then((res: any) => {
            let body: rolesEnum = res.responseObject;
            return Promise.resolve(body);
        })
}

const getRolesCount = () => {
    return axiosNTL.get('/role/getRolesCount')
        .then((res: any) => {
            let count = res.responseObject ? res.responseObject : 0;
            return Promise.resolve(count);
        })
}

const saveRole = (formBody: any) => {
    return axiosNL.post('/role', formBody)
        .then((res: any) => {
            let resp = res.responseObject;
            return Promise.resolve(resp)
        })
}

const updateRole = (formBody: any) => {
    return axiosNL.patch(`/role/updateRoles/${formBody._id}`, formBody)
        .then((res: any) => {
            let resp = res.statusCode && res.statusCode == 200 ? true : false;
            return Promise.resolve(resp)
        })
}

const deleteRole = (id: string, roleName: string) => {
    return axiosNL.delete(`/role/deleteRole/${id}/${roleName}`)
        .then((res: any) => {
            let resp = res.statusCode && res.statusCode == 200 ? true : false;
            return Promise.resolve(resp)
        })
}

export const UserRoleService = {
    listUserRoles,
    getRolesEnum,
    getRolesCount,
    saveRole,
    updateRole,
    deleteRole
};